<template>
    <div v-show="!hasModelli">{{ this.risorse["NoModelli"] }}</div>
    <div class="loaderCont" v-show="isLoading">
        <div class="loader loaderModelsList"></div> 
    </div> 
  
    <Model v-for="model in this.modelli" 
    :key="model.idMOdello"
    :urlImmagine="model.UrlImmagine"
    :descrizione="model.Descrizione"
    :idModello="model.IdModello"
    :idCategoria="model.IdCategoria"
    :idCatalogo="model.IdCatalogo">
    </Model>      
       
</template>

<script>

import Model from "@/components/Model.vue";
import {risorseMixin} from "@/mixin.js";

export default {
    name : "ModelList",
    components:{
        Model
       
    },
    data(){
        return {
            isLoading : true,
            hasModelli : true,
            modelli: []
        }
    },
    props:{
        modelsList : Array
    },
    
    watch: {
        modelsList: function(newValue){            
           
            if(newValue.length > 0 && newValue[0] != "no-models"){                
                this.hasModelli = true;
                this.isLoading = false;
                 this.modelli = newValue;
            }
            else if(newValue.length > 0 && newValue[0] == "no-models"){
                this.hasModelli = false;
                this.isLoading = false;
                this.modelli = [];
            }
            else{              
                this.isLoading = true;
            } 
        } 
    },
    mixins:[risorseMixin]
}
</script>
<style>
    .loaderCont{
        height: 100%;
        width: 100%;
        text-align: center;
        padding-top:10%;
    }

    .loaderModelsList{
        background: #fff;
        width: 40px;
        height: 40px;
    }
</style>
